import {
  useCuentaContableEmpresaCliente,
  useCuentaContableEmpresaProveedor,
} from "api/CuentaContableEmpresa.hook"
import mapContactoToApi from "features/Contactos/mappers/mapContactoToApi"
import {
  createContacto,
  editCuentasBancarias,
} from "features/Contactos/redux/slices/contactoSlice"
import { useDispatch } from "hooks/useDispatch"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import CrearContactoForm from "../../forms/CrearContacto/index"
import "./styles.scss"

const CrearContacto = ({
  isCliente,
  onHide,
  toggleIsContactCreatedDispatch,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { cuentasContablesEmpresasRefetch: refreshCuentaClientes } =
    useCuentaContableEmpresaCliente()
  const { cuentasContablesEmpresasRefetch: refreshCuentaProveedores } =
    useCuentaContableEmpresaProveedor()

  const crear = useCallback(
    (data: $TSMigrationFixMe) => {
      const payload = mapContactoToApi(data, true)
      // @ts-expect-error TS(2345): Argument of type...
      dispatch(editCuentasBancarias([]))
      dispatch(
        createContacto({
          contacto: payload,
          refreshCuentaClientes,
          refreshCuentaProveedores,
          toggleIsContactCreatedDispatch,
        })
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch]
  )

  const updateData = (newData: $TSMigrationFixMe) => {
    crear({ ...newData })
  }

  return (
    <CrearContactoForm
      // @ts-expect-error TS(2322): Type '{ isCliente: $TSFixMe; updateData: (newData: $TSFixMe)...
      isCliente={isCliente}
      updateData={updateData}
      onHide={onHide}
      t={t}
    />
  )
}

export default CrearContacto
